export default "__VITE_ASSET__Rp1lbiAS__"